export default function (axios) {
  return {
    getAnalytics(params) {
      return axios
        .get('/modules/transact/analytics/', params)
        .then((res) => res.data)
    },
  }
}
